// import BaseFormPresenter from "../../../../base/BaseFormPresenter";

import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";
import { upsertUseCase } from "../../../../usecases/object";

class JobPostingFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  // async submitBtn() {
  //   const data = {
  //     ...this.view.state.hierarchy,
  //     positionTitle: { id: this.view.state.selectedTitle.id },
  //     item_number: this.view.state.item_number,
  //     selectedSalary: { id: this.view.state.selectedSalary.id },
  //     compensation: this.view.state.compensation,
  //     typeApplicant: this.view.state.typeApplicant,
  //     typeApplication: this.view.state.typeApplication,

  //     // selectedOffice: this.view.state.selectedOffice,
  //     // selectedDivision: this.view.state.selectedDivision,
  //     reposting: this.view.state.reposting,
  //     publication: this.view.state.publication,
  //     education: this.view.state.education,
  //     eligibility: this.view.state.eligibility,
  //     experience: this.view.state.experience,
  //     training: this.view.state.training,
  //     generalscopeofwork: this.view.state.generalscopeofwork,
  //     qualificationstandard: this.view.state.qualificationstandard,
  //     dutiesandresponsibilities: this.view.state.dutiesandresponsibilities,
  //     corecompetencies: this.view.state.corecompetencies,
  //     organizationalcompetencies: this.view.state.organizationalcompetencies,
  //     leadershipcompetencies: this.view.state.leadershipcompetencies,
  //     technicalcompetencies: this.view.state.technicalcompetencies,
  //     otherqualifications: this.view.state.otherqualifications,
  //     submissionDeadline: this.view.state.deadlineofsubmission,
  //     acl: {},
  //     // dateClosed: null,
  //   };

  //   console.log("data", data);

  //   if (this.view.getObjectId() !== undefined) {
  //     // const newData = {
  //     //   ...data,
  //     //   id: this.view.getObjectId(),
  //     // };
  //     // await upsertUseCase().execute("job_postings", newData);
  //     // this.showSuccess("Successfully Saved!");
  //     data.id = this.view.getObjectId();
  //   }
  //   await upsertUseCase().execute("job_postings", data);
  //   this.showSuccess("Successfully Saved!");
  // }

  // showSuccess() {
  //   console.warn("SDFSDf");
  //   return this.showSuccess("WWWWWWWWWW");
  // }
  async save() {
    const collection = this.view.getCollectionName();
    if (this.object.id) {
      this.change.id = this.object.id;
    }
    try {
      this.change.acl = {};
      if (
        Array.isArray(this.change.positionTitle) &&
        this.change.positionTitle.length > 0
      ) {
        this.change.positionTitle = this.change.positionTitle.map(
          (relation) => {
            const result = { ...relation };

            // Remove or replace jobTitle
            if (relation.jobTitle?.id) {
              result.jobTitle = { id: relation.jobTitle.id };
            } else {
              delete result.jobTitle;
            }

            return result;
          }
        );
      }
      await this.upsertUseCase.execute(collection, this.change);
      this.showSuccess("Success");
      this.change = {};
    } catch (error) {
      throw error; // rethrow the error to be caught by the caller
    }
  }
}

export default JobPostingFormPresenter;
